import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import AddDiscountMaster from "./addDiscountMaster";
import GetAllDiscountMaster from "./getAllDiscountMaster";
import UploadDiscountMasterExcel from "./UploadDiscountMasterExcel";

const DiscountMaster = (props) => {
  const isLogged = Boolean(localStorage.getItem("isLogged"));
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  if (!isLogged) {
    return <Navigate to={"/auth/login"} replace={true} />;
  }

  const refreshList = () => {
    setAddModalOpen(false);
    setUploadModalOpen(false);
    setRefreshKey((k) => k + 1);
  };

  const addButton = (
    <Button
      type="primary"
      icon={<PlusOutlined />}
      onClick={() => setAddModalOpen(true)}
      style={{ backgroundColor: "#52c41a", borderColor: "#52c41a", fontWeight: 600 }}
    >
      Add Discount
    </Button>
  );

  const uploadButton = (
    <Button
      icon={<UploadOutlined />}
      onClick={() => setUploadModalOpen(true)}
      style={{ fontWeight: 600 }}
    >
      Import from Excel
    </Button>
  );

  return (
    <div>
      <Modal
        title="Add Discount"
        open={addModalOpen}
        onCancel={() => setAddModalOpen(false)}
        footer={null}
        destroyOnClose
        width={800}
      >
        <AddDiscountMaster
          inModal
          onSuccess={refreshList}
          onCancel={() => setAddModalOpen(false)}
        />
      </Modal>
      <Modal
        title="Import from Excel"
        open={uploadModalOpen}
        onCancel={() => setUploadModalOpen(false)}
        footer={null}
        destroyOnClose
        width={560}
      >
        <UploadDiscountMasterExcel onSuccess={refreshList} />
      </Modal>
      <GetAllDiscountMaster
        refreshTrigger={refreshKey}
        addDiscountMasterButton={addButton}
        uploadButton={uploadButton}
      />
    </div>
  );
};

export default DiscountMaster;
